<div class="bg-white px-2">
  <div class="flex flex-col md:flex-row justify-between items-center mb-2 gap-4">
    <p class="text-444 font-bold text-[13px] sm:text-sm lg:text-[15px] capitalize">Create New Accounts & Update
      Opening :</p>
    <div class="flex items-center gap-2 w-full md:w-auto">
      <label class="text-[13px] font-medium text-383838">Search:</label>
      <input type="text" [(ngModel)]="searchTerm" placeholder="Search account name or group..."
        class="border border-d9d9d9 rounded-md px-3 py-1 text-[13px] w-full md:w-80 focus:outline-none focus:border-c19725" />
    </div>
  </div>

  <div class="overflow-x-auto w-full mt-2 space-y-2">
    <table class="listtable1 border border-d9d9d9 bg-white w-full">
      <thead class="bg-f2ffe6 text-444 rounded-lg">
        <tr>
          <th class="text-center font-medium text-[13px] sm:text-sm lg:text-[15px] px-1.5 py-2 whitespace-nowrap">
            Sr No.
          </th>
          <th class="text-center font-medium text-[13px] sm:text-sm lg:text-[15px] px-1.5 py-2 whitespace-nowrap">
            New Account Name
          </th>
          <th class="text-center font-medium text-[13px] sm:text-sm lg:text-[15px] px-1.5 py-2 whitespace-nowrap">
            Primary Group
          </th>
          <th class="text-center font-medium text-[13px] sm:text-sm lg:text-[15px] px-1.5 py-2 whitespace-nowrap">
            Amount
          </th>
          <th class="text-center font-medium text-[13px] sm:text-sm lg:text-[15px] px-1.5 py-2 whitespace-nowrap">
            CR / DR
          </th>
          <th class="text-center font-medium text-[13px] sm:text-sm lg:text-[15px] px-1.5 py-2 whitespace-nowrap">
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of filteredRows; let i = index">
          <!-- sr no -->
          <td class="text-center text-444 font-normal text-[13px] sm:text-sm lg:text-[15px] px-1.5 py-2">
            {{ rows.indexOf(row) + 1 }}
          </td>
          <!-- New Account Name -->
          <td class="text-center text-757575 font-normal text-[13px] sm:text-sm lg:text-[15px] px-1.5 py-2">
            <div class="relative">
              <input type="text" [id]="'acc_user_acc_' + i" [name]="'acc_user_acc_' + i" placeholder=" "
                [(ngModel)]="row.acc_user_acc"
                class="block px-1 py-2 w-full text-[13px] text-383838 font-normal bg-white rounded-md border border-d9d9d9 appearance-none !bg-none focus:outline-none focus:ring-0 focus:border-c19725 peer" />
              <label [for]="'acc_user_acc_' + i"
                class="absolute text-[13px] text-9ca0a9 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-left bg-white px-1 peer-focus:px-1 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Account
                Name</label>
            </div>
          </td>
          <!-- Primary Group -->
          <td class="text-center text-757575 font-normal text-[13px] sm:text-sm lg:text-[15px] px-1.5 py-2">
            <div class="w-max sm:w-full relative">
              <select [id]="'acc_main_acc_' + i" [name]="'acc_main_acc_' + i" [(ngModel)]="row.acc_main_acc" required
                class="block px-1 py-2 w-full text-[13px] text-383838 font-normal bg-white rounded-md border border-d9d9d9 appearance-none !bg-none focus:outline-none focus:ring-0 focus:border-c19725 peer">
                <option value="" disabled hidden></option>
                <option *ngFor="let account of accounts" [value]="account">{{ account }}</option>
              </select>
              <label [for]="'acc_main_acc_' + i"
                class="absolute text-[13px] text-9ca0a9 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-left bg-white px-1 peer-focus:px-1 peer-focus:text-c19725  peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1 whitespace-nowrap">Account
                Group</label>
              <div class="absolute inset-y-0 right-2 flex items-center pointer-events-none">
                <svg width="8" height="4" viewBox="0 0 6 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 0L2.85817 2.44986L5.71633 0H0Z" fill="#C19725" />
                </svg>
              </div>
            </div>
          </td>
          <!-- Amount -->
          <td class="text-left text-757575 font-normal text-[13px] sm:text-sm lg:text-[15px] px-1.5 py-2">
            <div class="w-max sm:w-full relative">
              <input type="number" [id]="'acc_cash_balance_' + i" [name]="'acc_cash_balance_' + i" placeholder=" "
                [(ngModel)]="row.acc_cash_balance" (input)="calculateTotals()"
                class="block px-1 py-2 w-full text-[13px] text-383838 font-normal bg-white rounded-md border border-d9d9d9 appearance-none !bg-none focus:outline-none focus:ring-0 focus:border-c19725 peer" />
              <label [for]="'acc_cash_balance_' + i"
                class="absolute text-[13px] text-9ca0a9 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-left bg-white px-1 peer-focus:px-1 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1 whitespace-nowrap">Opening
                Amount</label>
            </div>
          </td>
          <!-- CR/DR -->
          <td class="text-center text-757575 font-normal text-[13px] sm:text-sm lg:text-[15px] px-1.5 py-2">
            <div class="w-full relative">
              <select [id]="'acc_cash_balance_crdr_' + i" [name]="'acc_cash_balance_crdr_' + i"
                [(ngModel)]="row.acc_cash_balance_crdr" (change)="calculateTotals()" required
                class="block px-1 py-2 w-full text-[13px] text-383838 font-normal bg-white rounded-md border border-d9d9d9 appearance-none !bg-none focus:outline-none focus:ring-0 focus:border-c19725 peer">
                <option value="" disabled hidden></option>
                <option *ngFor="let type of crdrTypes" [value]="type">{{ type }}</option>
              </select>
              <label [for]="'acc_cash_balance_crdr_' + i"
                class="absolute text-[13px] text-9ca0a9 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-left bg-white px-1 peer-focus:px-1 peer-focus:text-c19725  peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1 whitespace-nowrap">CR
                / DR</label>
              <div class="absolute inset-y-0 right-2 flex items-center pointer-events-none">
                <svg width="8" height="4" viewBox="0 0 6 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 0L2.85817 2.44986L5.71633 0H0Z" fill="#C19725" />
                </svg>
              </div>
            </div>
          </td>
          <!-- Add & Delete buttons -->
          <td class="text-center text-757575 font-normal text-[13px] sm:text-sm lg:text-[15px] px-1.5 py-2">
            <div class="flex items-center justify-center gap-2">
              <!-- add button: only on the absolute last row of the original list -->
              <button *ngIf="row === rows[rows.length - 1]" type="button" (click)="addRow()"
                class="cursor-pointer p-1 bg-0bb60b rounded-md">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6 12H18M12 6V18" stroke="#ffffff" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round"></path>
                </svg>
              </button>
              <!-- delete button: only on new rows not saved to DB -->
              <button *ngIf="!row.id" type="button" (click)="removeRow(row)"
                class="cursor-pointer p-1 bg-bb0000 rounded-md">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10 12V17" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M14 12V17" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M4 7H20" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M6 10V18C6 19.6569 7.34315 21 9 21H15C16.6569 21 18 19.6569 18 18V10" stroke="#ffffff"
                    stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z" stroke="#ffffff"
                    stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="text-end space-y-2 mt-4">
    <p class="text-444 font-normal text-end text-[13px] sm:text-sm lg:text-[15px] capitalize">CR Amount : <span
        class="min-w-30 inline-block text-right">{{ totalCr | number:'1.2-2' }}</span></p>
    <p class="text-444 font-normal text-end text-[13px] sm:text-sm lg:text-[15px] capitalize">DR Amount : <span
        class="min-w-30 inline-block text-right">{{ totalDr | number:'1.2-2' }}</span></p>
    <p class="text-444 font-normal text-end text-[13px] sm:text-sm lg:text-[15px] capitalize">Difference : <span
        class="min-w-30 inline-block text-right font-bold">{{ difference | number:'1.2-2' }}</span></p>
  </div>
  <!-- SUBMIT BUTTON -->
  <div class="mt-6 mb-4 flex items-center justify-center">
    <button type="button" (click)="onSubmit()"
      class="w-full sm:w-48 px-2 sm:px-4 py-2 cursor-pointer rounded-md bg-018f37 border border-018f37 text-white text-sm sm:text-base font-medium hover:bg-green-700 hover:shadow-lg transition-all duration-200">
      Submit
    </button>
  </div>
</div>